import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from './shared/services/shared.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'home365-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit{
  title = 'support';

  constructor(
    private translate: TranslateService,
    private sharedService: SharedService,
  ) {
    translate.setDefaultLang('en');
    translate.use('en')
  }

  ngOnInit(): void {
   console.log({version: environment.version});
  }
}
